export const sidebar_action = "sidebar_action/change";

export const sidebarShow = () => ({
    type: sidebar_action,
    payload: {
        display: true
    }
});

export const sidebarHide = () => ({
    type: sidebar_action,
    payload: {
        display: false
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/sidebar.js